var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex filters"},[_c('search'),_c('gender'),_c('dateCreated'),_c('location'),(!_vm.isTurkish)?_c('origin'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }